<template>
  <div class="container">
    <app-modal
      v-model="showOrganizationPopup"
      :title="createPopupTitle"
      no-margin
    >
      <organization-form-tabs
        v-model="organization"
        @create="saveOrganization"
        @update="saveOrganization"
        @close="showOrganizationPopup = false"
      ></organization-form-tabs>
    </app-modal>

    <app-data-view-header
      has-create
      :view-by.sync="viewBy"
      :search.sync="search"
      :headers="headers"
      :sort="sortSettings"
      :order-by.sync="orderBy"
      @click:create="openCreateOrganizationPopup"
    >
    </app-data-view-header>
    <app-data-viewer
      grid-has-edit
      :loading="loadingList"
      :items="filteredItems"
      :view-by="viewBy"
      :order-by.sync="orderBy"
      :headers="headers"
      @click:grid-edit="openEditOrganizationPopup($event)"
      @click:list-row="gotoProjects($event)"
      @click:grid-item="gotoProjects($event)"
    >
      <template v-slot:grid.subtitle="{ modifiedOnUTC, projectsCount }">
        <div class="columns">
          <div class="column is-4">
            <span class="grid-stat-label">Projects</span>
            <span class="grid-stat-value">{{ projectsCount }}</span>
          </div>
          <div class="column is-8">
            <span class="grid-stat-label">Last edited</span>
            <span class="grid-stat-value">
              {{ modifiedOnUTC | humanTimeFromNow }}
            </span>
          </div>
        </div>
      </template>
      <template v-slot:list.item.actions="{ item }">
        <button
          class="button is-text is-icon"
          @click.stop="openEditOrganizationPopup(item)"
        >
          <span class="icon icon-edit"></span>
        </button>
      </template>
    </app-data-viewer>
  </div>
</template>

<script>
import AppDataViewHeader from '@/components/AppDataViewHeader.vue';
import AppDataViewer from '@/components/AppDataViewer.vue';
import AppModal from '@/components/AppModal';
//import AppDivision from '@/components/AppDivision.vue';
import OrganizationFormTabs from '@/components/forms/OrganizationFormTab.vue';
//import { ValidationProvider, ValidationObserver } from 'vee-validate';
import '@/validation.js';
import _ from 'lodash';

export default {
  name: 'OrganizationsList',
  components: {
    OrganizationFormTabs,
    AppDataViewHeader,
    AppDataViewer,
    AppModal
    /*ValidationProvider,
    ValidationObserver,
    AppDivision,*/
  },
  data() {
    return {
      showOrganizationPopup: false,
      createPopupTitle: '',
      organization: {},
      divisions: [],
      headers: [
        {
          text: 'Name',
          value: 'name',
          sortable: true,
          customSort: (a, b) => {
            if (a.__name < b.__name) {
              return -1;
            }
            if (a.__name > b.__name) {
              return 1;
            }
            return 0;
          }
        },
        {
          text: 'Projects',
          value: 'projectsCount',
          orderByText: '# Projects',
          sortable: true,
          align: 'center',
          parser: value => `${value} projects`
        },
        { text: 'Team', value: 'team' },
        {
          text: '',
          value: 'actions',
          align: 'end',
          width: 100 /*,
          permissions: [30002, 30001]*/
        }
      ],
      sortSettings: [
        {
          text: 'Name',
          value: 'name',
          sortDirection: 1,
          customSort: (a, b) => {
            if (a.__name < b.__name) {
              return -1;
            }
            if (a.__name > b.__name) {
              return 1;
            }
            return 0;
          }
        }
      ],
      loadingList: true,
      viewBy: 'grid',
      orderBy: {},
      search: ''
    };
  },
  computed: {
    filteredItems() {
      const items = this.$store.getters['organizations/search'](this.search);
      /*const usersByOrganization = this.$store.getters[
        'users/listByOrganization'
      ];*/
      const allUsers = this.$store.getters['users/list'];
      return _.map(items, i => {
        i.projectsCount = 0;
        i.groups.map(item => {
          i.projectsCount += item.projects.length;
        });
        //i.users = _.get(usersByOrganization, i.organizationID, []);
        i.users = allUsers.filter(user => {
          for (let j = 0; j < user.roles.length; j++) {
            if (
              user.roles[j].roleID == 10 ||
              user.roles[j].organizationID == i.organizationID
            ) {
              return true;
            }
          }

          return false;
        });

        //console.log(':::', i.organizationID, i.users);
        if (!i.modifiedOnUTC) i.modifiedOnUTC = i.createdOnUTC;
        return i;
      });
    }
  },
  mounted() {
    this.axiosRequest('get', 'Organizations')
      .then(response => {
        this.$store.commit('organizations/set', response.data);
        this.loadingList = false;
      })
      .catch(error => {
        this.showErrorMessage(error);
      });
  },
  methods: {
    openCreateOrganizationPopup() {
      this.showOrganizationPopup = true;
      this.organization = {};
      this.createPopupTitle = 'Create new Organization';
    },
    openEditOrganizationPopup(item) {
      this.showOrganizationPopup = true;
      this.organization = this.$store.getters['organizations/byId'](
        item.organizationID
      );
      //this.organization = item;
      this.createPopupTitle = 'Edit Organization';
      let divisions_tmp = this.$store.getters['groups/items'];

      divisions_tmp = divisions_tmp.filter(item => {
        if (
          item.organizationLevel == 'Division' &&
          item.organizationID == this.organization.organizationID
        )
          return item;
      });

      divisions_tmp = divisions_tmp.map(item_division => {
        //this.$set(item_division, 'workgroups', []);
        const tmp = this.$store.getters['groups/items'].filter(
          item_workgroup => {
            if (
              item_workgroup.organizationLevel == 'Workgroup' &&
              item_workgroup.parentGroupID == item_division.groupID
            ) {
              return item_workgroup;
            }
          }
        );
        this.$set(item_division, 'workgroups', tmp);

        return item_division;
      });

      this.divisions = divisions_tmp;
    },
    gotoProjects(item) {
      this.$router.push({
        name: 'projects.list',
        params: { organizationID: item.organizationID }
      });
    },
    saveOrganization(buttons, groups) {
      console.log('saveOrganization', buttons, groups);
      let method = 'post';
      let path = 'Organizations';
      if (this.organization.organizationID) {
        method = 'put';
        path += '/' + this.organization.organizationID;
      }

      //this.organization.groups = groups;
      let organizationGroup = [];
      for (let i = 0; i < groups.length; i++) {
        if (groups[i].division.name != '') {
          organizationGroup.push(groups[i].division);

          for (let j = 0; j < groups[i].workgroups.length; j++) {
            if (groups[i].workgroups[j].name != '') {
              organizationGroup.push(groups[i].workgroups[j]);
            }
          }
        }
      }

      this.axiosRequest(method, path, {
        name: this.organization.name,
        groups: organizationGroup
      })
        .then(response => {
          if (!this.organization.organizationID) {
            this.$store.commit('organizations/add', response.data);
            for (let i = 0; i < response.data.groups.length; i++) {
              this.$store.commit('groups/add', response.data.groups[i]);
              this.organization = response.data;
            }
          } else {
            this.$store.commit('organizations/edit', response.data);
            this.showOrganizationPopup = false;
            this.organization = {};
            //TODO should we fetch all groups again? Because there is no "easy way" to track what happen to groups, edited, deleted or added...
          }

          //this.organization = response.data;
          //this.organization = {};
          this.divisions = [];

          for (let i = 0; i < buttons.length; i++) {
            buttons[i].organizationID = response.data.organizationID;
            if (!buttons[i].deleted) {
              this.saveButton(buttons[i]);
            } else {
              this.deleteButton(buttons[i]);
            }
          }
        })
        .catch(error => {
          this.showErrorMessage(error);
        });
    },
    addDivision() {
      const group = _.find(this.organization.groups, {
        organizationLevel: 'Organization'
      });

      this.divisions.unshift({
        organizationID: this.organization.organizationID,
        name: '',
        parentGroupID: group.groupID,
        workgroups: []
      });
    },
    deleteGroup(group) {
      this.axiosRequest('delete', `Groups/${group.groupID}`)
        .then(() => {
          this.$store.commit('groups/deleteById', group.groupID);
          if (group.organizationLevel == 'Division') {
            const idx = _.findIndex(this.divisions, {
              groupID: group.groupID
            });
            this.divisions.splice(idx, 1);
          } else {
            const idx_division = _.findIndex(this.divisions, {
              groupID: group.parentGroupID
            });
            const idx_wg = _.findIndex(
              this.divisions[idx_division].workgroups,
              {
                groupID: group.groupID
              }
            );
            this.divisions[idx_division].workgroups.splice(idx_wg, 1);
          }
        })
        .catch(error => {
          this.showErrorMessage(error);
        });
    },
    saveGroup(group) {
      console.log('save group', group);
      let method = 'post';
      let path = 'Groups';
      if (group.groupID) {
        method = 'put';
        path += '/' + group.groupID;
      }

      this.axiosRequest(method, path, {
        organizationID: group.organizationID,
        name: group.name,
        parentGroupID: group.parentGroupID
      })
        .then(response => {
          if (!group.groupID) {
            //insert
            this.$set(group, 'groupID', response.data.groupID);
            this.$store.commit('groups/add', response.data);
          } else {
            //update
            this.$store.commit('groups/edit', group);
          }
        })
        .catch(error => {
          this.showErrorMessage(error);
        });
    },
    saveButton(button) {
      //console.log('save button', button);
      let method = 'post';
      let path = 'Buttons';
      if (button.buttonID) {
        method = 'put';
        path += '/' + button.buttonID;
      }

      let organization = this.$store.getters['organizations/byId'](
        button.organizationID
      );

      this.axiosRequest(method, path, {
        organizationID: button.organizationID,
        groupID: button.groupID,
        title: button.title,
        titleLink: button.titleLink
      })
        .then(response => {
          for (let i = 0; i < organization.groups.length; i++) {
            if (organization.groups[i].groupID == response.data.groupID) {
              if (!button.buttonID) {
                organization.groups[i].buttons.push(response.data);
              } else {
                for (
                  let y = 0;
                  y < organization.groups[i].buttons.length;
                  y++
                ) {
                  if (
                    organization.groups[i].buttons[y].buttonID ==
                    response.data.buttonID
                  ) {
                    this.$set(organization.groups[i].buttons, y, response.data);
                  }
                }
              }
              this.$store.commit('organizations/edit', organization);
              break;
            }
          }
        })
        .catch(error => {
          this.showErrorMessage(error);
        });
    },
    deleteButton(button) {
      console.log(button);
      this.axiosRequest('delete', `Buttons/${button.buttonID}`)
        .then(() => {
          let organization = this.$store.getters['organizations/byId'](
            button.organizationID
          );
          for (let i = 0; i < organization.groups.length; i++) {
            if (organization.groups[i].groupID == button.groupID) {
              for (let y = 0; y < organization.groups[i].buttons.length; y++) {
                if (
                  organization.groups[i].buttons[y].buttonID == button.buttonID
                ) {
                  organization.groups[i].buttons.splice(y, 1);
                  this.$store.commit('organizations/edit', organization);
                  break;
                }
              }
            }
          }
        })
        .catch(error => {
          this.showErrorMessage(error);
        });
    }
  }
};
</script>

<style lang="scss"></style>
